import { render, staticRenderFns } from "./thaiQRExtra.vue?vue&type=template&id=4f2f89a8"
import script from "./thaiQRExtra.vue?vue&type=script&lang=ts"
export * from "./thaiQRExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports